import axios from '../request'
export default {
    getValidateCode(data) {
        return axios({ name: '获取验证码', method: 'get', url: '/captcha', data })
    },
    SearchResult(data) {
        return axios({ name: '查询防伪码结果', method: 'post', url: '/serve-user/app-api/v1/security-code/check', data })
    },
}